export default {
  emits: ['onselect'],
  props: {
    parent: { // parent element
      type: Object,
      required: true,
    },
    page: { // page element
      type: Object,
      required: true,
    },
    index: Number, // above element index
  },
  methods: {
    addChild(type, data, children, metaData) {
      let rank = this.index === 0 ? 0 : this.parent.children[this.index - 1].rank + 1
      
      const newChild = {
        parent__bc_document_data_rev_id: this.parent.type !== 'document' ? this.parent.id : null,
        type,
        data,
        metaData, // data which is added to data only in update / create
        rank,
        children: [],
        comments: [],
        updated: true,
        key: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)
      }

      if (children !== undefined) {
        newChild.children = children
        newChild.children.forEach((childElement) => {
          if (childElement.parent__bc_document_data_rev_id) {
            delete childElement.parent__bc_document_data_rev_id
          }
          childElement.key = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)
        })
      }

      this.parent.children.splice(this.index, 0, newChild)

      // recount rank
      for (let index = 0; index < this.parent.children.length; index++) {
        this.parent.children[index].rank = index
        //this.parent.children[index].updated = true
      }
    }
  }
}
